
import React from 'react';
import { connect } from "react-redux";
import Logo from './../../../images/Billy-Logo-White.png'
import { BiLogOutCircle } from 'react-icons/bi';
import { FaUserCircle } from 'react-icons/fa';
import logout from './../../../Global/logout'
import ReactNotification from 'react-notifications-component'
import 'react-notifications-component/dist/theme.css'
import { FaBars } from 'react-icons/fa';
import { IconContext } from 'react-icons/lib';

export class TopBar extends React.Component{

    handleToggleSidebar(e){
        this.props.mapState("ASIDE_TOGGLER", !this.props.asideToggled)
    }

    render(){
        return (
            <div className="topBar" style={{height: "60px", width: "100%", backgroundColor: "rgb(22,40,111)"}}>
                <ReactNotification />

                <div className="btn-toggle topbar-sidebar" onClick={() => this.handleToggleSidebar(true)}>
                    <IconContext.Provider 
                        value={{ 
                            style:{ 
                                verticalAlign: 'middle',
                                border: '15px',
                                width:'25px',
                                height: '25px',
                                left: '10px',
                                marginRight: '30px',
                                position: 'relative'
                            } 
                        }}
                    >
                        <FaBars/>
                    </IconContext.Provider>
                </div>
                
                <img src={Logo} alt="logo" style={{height: "60px", padding:"10px"}}/>
                

                <BiLogOutCircle 
                size={40} 
                style={{float: "right", margin: "10px"}} 
                onClick={logout}
                className="hoverPointer hoverColorRed"
                />
                <FaUserCircle size={40} style={{float: "right", margin: "10px"}}/>

                <div style={{float: "right", marginTop: "10px", lineHeight: "normal"}}>
                    <span style={{fontSize: "18px"}}><strong>{this.props.credentials}</strong></span>
                    <br/>
                    <span>Account Settings</span>
                </div>
                
                
            </div>

        );
    };
}


const mapStateToProps = state => {
  return {
      userLoggedIn: state.client.userLoggedIn,
      credentials: state.client.credentials
  };
};

const mapDispatchToProps = dispatch => {
  return {
    mapState: (type, data) => dispatch({ type: type, data: data})
  };
};



export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TopBar);

